import { NgModule } from '@angular/core';
import { UpgradeModule } from '@angular/upgrade/static';
import {
	CommonModule,
	CurrencyPipe,
	DatePipe,
	DecimalPipe,
	APP_BASE_HREF,
	Location,
	LocationStrategy,
	PathLocationStrategy
} from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, UrlHandlingStrategy, UrlTree } from '@angular/router';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DragulaModule } from 'ng2-dragula';
import { ImageCropperComponent } from 'ngx-img-cropper';
import { MyDatePickerModule } from 'mydatepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { TextMaskModule } from 'angular2-text-mask';
import '../shared/rxjs-operators';
import { AppComponent } from './app.component';
import { WebRequestsInterceptor } from './modern/webRequestsInterceptor';
import { downgradedComponents } from './modern/components/modernComponents';
import { WebServicesModule } from './modern/services/services.module';
import { TimeFilterPipe } from '../shared/pipes/time-filter/time-filter';
import { PipesModule } from '../shared/pipes/pipes.module';
import { AppConstants } from '../shared/models/appConstants';
import { SnDatePickerValidatorDirective } from './modern/directives/sn-date-picker-validator/sn-date-picker-validator.directive';
import { SnDateRangePickerDirective } from './modern/components/common/sn-date-range-picker/sn-date-range-picker.directive';
import { AmountValidationDirective } from './modern/directives/AmountValidation/amountValidation.directive';
import { CutStringFilterPipe } from '../shared/pipes/cut-string/cut-string';
import { SpinningWheelComponent } from '../shared/components/common/spinning-wheel/spinning-wheel';
import { BoldPipeFilter } from '../shared/pipes/bold/boldPipe';
import { QuillModule } from 'ngx-quill';
import { NgbActiveModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ClipboardModule } from 'ngx-clipboard';
import { NgxDropzoneModule } from 'ngx-dropzone';

const pipes = [
	DatePipe,
	CurrencyPipe,
	DecimalPipe,
	TimeFilterPipe,
	BoldPipeFilter,
	CutStringFilterPipe
];

const snDirectives = [
	AmountValidationDirective,
	SnDatePickerValidatorDirective,
	SnDateRangePickerDirective,
	SpinningWheelComponent
];

class HybridUrlHandlingStrategy implements UrlHandlingStrategy {
	// use only process the `/bar` url
	shouldProcessUrl(url: UrlTree) {
		return url.toString().startsWith('/bar');
	}

	extract(url: UrlTree) {
		return url;
	}

	merge(url: UrlTree, whole: UrlTree) {
		return url;
	}
}

@NgModule({
	imports: [
		CommonModule,
		BrowserModule,
		UpgradeModule,
		HttpClientModule,
		FormsModule,
		PipesModule,
		MyDatePickerModule,
		ReactiveFormsModule,
		DragulaModule,
		NgxDaterangepickerMd,
		TextMaskModule,
		NgbModalModule.forRoot(),
		QuillModule.forRoot(),
		WebServicesModule.forRoot(),
		BsDropdownModule.forRoot(),
		RouterModule.forRoot([], {}),
		ClipboardModule,
		NgxDropzoneModule
		// RouterModule.forRoot([], { initialNavigation: false }),
	],
	providers: [
		...pipes,
		Location,
		NgbActiveModal,
		{ provide: LocationStrategy, useClass: PathLocationStrategy },
		{ provide: UrlHandlingStrategy, useClass: HybridUrlHandlingStrategy },
		{
			provide: APP_BASE_HREF,
			useValue:
				AppConstants.IS_PROD_BUILD || AppConstants.IS_TEST_BUILD
					? window['_app_base']
					: '/'
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: WebRequestsInterceptor,
			multi: true
		},
		{
			provide: '$routeParams',
			useFactory: ($injector: any) => $injector.get('$routeParams'),
			deps: ['$injector']
		},
		{
			provide: '$rootScope',
			useFactory: ($injector: any) => $injector.get('$rootScope'),
			deps: ['$injector']
		}
	],
	declarations: [
		AppComponent,
		ImageCropperComponent,
		...snDirectives,
		...downgradedComponents
	],
	entryComponents: [...downgradedComponents],
	bootstrap: [AppComponent]
})
export class AppModule {
	ngDoBootstrap() {}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/app.module.ts